const DOMAIN_PRODUCTION = "the-brain.dive.tech";
const DOMAIN_STAGING = "staging.siren.clients.dive.tech";

const defaults = {
  KEYCLOAK_URL: "https://auth.dev.the-brain.clients.dive.tech",
  KEYCLOAK_REALM: "ispd",
  KEYCLOAK_CLIENT_ID: "antevenio",
  // BACKEND_API_URL: "http://localhost:8080/",
  BACKEND_API_URL: window.location.origin,
  // ACCESS_MANAGER_API_URL: "http://localhost:8090/",
  ACCESS_MANAGER_API_URL: window.location.origin,
  // SOURCE_MANAGER_API_URL: "http://localhost:8095/",
  SOURCE_MANAGER_API_URL: window.location.origin
};

const variables = {
  development: {
    ...defaults,
    KEYCLOAK_URL:
      (process.env.REACT_APP_KEYCLOAK_URL as string) || defaults.KEYCLOAK_URL,
    KEYCLOAK_REALM:
      (process.env.REACT_APP_KEYCLOAK_REALM as string) ||
      defaults.KEYCLOAK_REALM,
    KEYCLOAK_CLIENT_ID:
      (process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string) ||
      defaults.KEYCLOAK_CLIENT_ID,
    BACKEND_API_URL:
      (process.env.REACT_APP_BACKEND_API_URL as string) ||
      defaults.BACKEND_API_URL,
    ACCESS_MANAGER_API_URL:
      (process.env.REACT_APP_ACCESS_MANAGER_API_URL as string) ||
      defaults.ACCESS_MANAGER_API_URL,
    SOURCE_MANAGER_API_URL:
      (process.env.REACT_APP_SOURCE_MANAGER_API_URL as string) ||
      defaults.SOURCE_MANAGER_API_URL
  },
  staging: {
    ...defaults,
    KEYCLOAK_URL: "https://auth.staging.the-brain.clients.dive.tech",
    KEYCLOAK_REALM: "ispd",
    KEYCLOAK_CLIENT_ID: "antevenio"
  },
  production: {
    ...defaults,
    KEYCLOAK_URL: "https://auth.the-brain.dive.tech",
    KEYCLOAK_REALM: "ispd",
    KEYCLOAK_CLIENT_ID: "antevenio"
  }
};

const getVariables = () => {
  if (window.location.host === DOMAIN_PRODUCTION) {
    return variables.production;
  }

  if (window.location.host === DOMAIN_STAGING) {
    return variables.staging;
  }

  return variables.development;
};

export const {
  KEYCLOAK_URL,
  KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID,
  BACKEND_API_URL,
  ACCESS_MANAGER_API_URL,
  SOURCE_MANAGER_API_URL
} = getVariables();
